export default __webpack_public_path__ + "static/media/hyderabad.822ee203.svg";